const toast = document.querySelector('.j-notification')

const setup = () => {
	if (toast) {
		toast.addEventListener('animationend', () => {
			toast.classList.remove('u-show')
		})
	}
}

const displayNotification = ({ message, type = undefined, delay = 3 }) => {
	if(toast) {
		toast.querySelector('.c-toast-notifications__body').innerHTML = message
		toast.setAttribute('style', delay ? `--delay: ${Number(delay)}s` : '')
		toast.classList.remove(
			'c-toast-notifications--success',
			'c-toast-notifications--warning',
			'c-toast-notifications--error',
		)
		toast.classList.add(type ? `c-toast-notifications--${type}` : '', 'u-show')
	}
}

const info = (message, delay) => {
	displayNotification({
		message,
		delay,
	})
}

const success = (message, delay) => {
	displayNotification({
		message,
		delay,
		type: 'success'
	})
}

const warning = (message, delay) => {
	displayNotification({
		message,
		delay,
		type: 'warning'
	})
}

const error = (message, delay) => {
	displayNotification({
		message,
		delay,
		type: 'error'
	})
}

setup()

export default {
	info,
	success,
	warning,
	error,
}

export { info, success, warning, error }

